export default "__VITE_ASSET__Cm1drCk7__"